import i18n from '@/i18n';

export default {
  // Categories are configured in the DB: their labels come with them, not from the i18n files.
  label(category) {
    const translation = (category.translations || []).find(
      (item) => item.langCode === i18n.locale
    );
    return translation ? translation.label : category.label;
  },
};
